module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("aaYQP"))).then(() => parcelRequire('d0iPb'));